import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Fade,
  Snackbar,
  Alert,
  AlertTitle,
  Typography,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import CloseIcon from "@mui/icons-material/Close";

import warningIcon from "../assets/icons/warning-icon-1.png";

export const FistoContext = React.createContext();

const FistoProvider = ({ children }) => {
  const [dialog, setDialog] = React.useState({
    open: false,
    wait: false,
    loading: false,

    message: "Are you sure you want to proceed?",

    onConfirm: undefined,
  });

  const [snackbar, setSnackbar] = React.useState({
    open: false,
    duration: 5000,
    severity: "success",
    title: "",
    message: "",
  });

  const onCloseDialog = () => {
    setDialog((currentValue) => ({
      ...currentValue,
      open: false,
      loading: false,
      wait: false,
    }));
  };

  const onCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;

    setSnackbar((currentValue) => ({
      ...currentValue,
      open: false,
    }));
  };

  const confirm = (params) => {
    const {
      open = true,
      wait = false,

      message = "Are you sure you want to proceed?",

      onConfirm = () => {},
    } = params;

    setDialog((currentValue) => ({
      ...currentValue,
      open,
      wait,
      message,
      onConfirm,
    }));
  };

  const toast = (params) => {
    const { open = true, duration = 5000, severity = "success", title = "", message = "" } = params;

    setSnackbar((currentValue) => ({
      ...currentValue,
      open,
      duration,
      severity,
      title,
      message,
    }));
  };

  return (
    <FistoContext.Provider value={{ confirm, toast }}>
      {/* App content here */}
      {children}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.duration}
        onClose={onCloseSnackbar}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transitionDuration={{
          enter: 300,
          exit: 300,
        }}
        TransitionComponent={Fade}
      >
        <Alert
          severity={snackbar.severity}
          onClose={onCloseSnackbar}
          sx={{
            maxWidth: 270,
          }}
        >
          <AlertTitle>{snackbar.title}</AlertTitle>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog open={dialog.open} disablePortal className="FstoConfirmationDialog">
        <DialogTitle className="FstoConfirmationDialogTitle-root">
          <IconButton size="small" onClick={onCloseDialog} tabIndex={-1}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="FstoConfirmationDialogContent-root">
          <img src={warningIcon} alt="warning" className="FstoConfirmation-icon" />
          <Typography variant="h6" fontSize={18} fontWeight={700}>
            Confirm Your Action
          </Typography>
          <Typography variant="body2" color="gray" fontWeight={500}>
            {dialog.message}
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{ marginRight: 0, justifyContent: "center", alignItems: "center", gap: "8px" }}
        >
          <Button
            className="FstoButtonTransaction-root FstoButtonSecondary-contained"
            variant="contained"
            size="medium"
            sx={{ borderRadius: "8px", textTransform: "capitalize" }}
            onClick={onCloseDialog}
            disableElevation
          >
            No, keep it.
          </Button>

          <LoadingButton
            className="FstoButtonTransaction-root  FstoButtonPrimary-root"
            variant="contained"
            loadingPosition="start"
            loading={dialog.loading}
            size="medium"
            startIcon={<></>}
            sx={{
              marginLeft: "0 !important",
              borderRadius: "8px",
              textTransform: "capitalize",

              "& .MuiLoadingButton-loadingIndicator": {
                left: 6,
              },
            }}
            onClick={async () => {
              if (dialog.onConfirm) {
                setDialog((currentValue) => ({
                  ...currentValue,
                  loading: true,
                }));

                if (dialog.wait) await dialog.onConfirm();
                else dialog.onConfirm();
              }
              onCloseDialog();
            }}
            disableElevation
          >
            Yes, Proceed.
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </FistoContext.Provider>
  );
};

export default FistoProvider;
